import { useState, useEffect } from 'react';
import ImageIcon from '../../Images/image-icon.png';

const ImageInput = ({
	onChange,
	fileName,
	previewUrl: externalPreviewUrl = null,
}) => {
	const [previewUrl, setPreviewUrl] = useState(externalPreviewUrl);
	const [isInternal, setIsInternal] = useState(false);

	useEffect(() => {
		if (!isInternal) {
			setPreviewUrl(externalPreviewUrl);
		}
	}, [externalPreviewUrl, isInternal]);

	useEffect(() => {
		return () => {
			if (isInternal && previewUrl) {
				URL.revokeObjectURL(previewUrl);
			}
		};
	}, [previewUrl, isInternal]);

	const handleDrop = (e) => {
		e.preventDefault();
		const file = e.dataTransfer.files[0];
		if (file && file.type.startsWith('image/')) {
			onChange?.({ target: { files: [file] } });
			const url = URL.createObjectURL(file);
			setPreviewUrl(url);
			setIsInternal(true);
		} else {
			alert('Please upload a valid image file (png, jpg, gif, etc.).');
		}
	};

	const handleDragOver = (e) => {
		e.preventDefault();
	};

	const handleFileChange = (e) => {
		const file = e.target.files[0];
		if (file && file.type.startsWith('image/')) {
			onChange?.(e);
			const url = URL.createObjectURL(file);
			setPreviewUrl(url);
			setIsInternal(true);
		} else {
			alert('Please upload a valid image file (png, jpg, gif, etc.).');
		}
	};

	return (
		<div
			className='w-full mx-auto border border-gray-300 mt-8 rounded-lg shadow-md text-center cursor-pointer bg-white relative'
			onDrop={handleDrop}
			onDragOver={handleDragOver}
		>
			{previewUrl && (
				<div className='p-4'>
					<img
						src={previewUrl}
						alt='Preview'
						className='mx-auto max-h-48 object-contain rounded'
					/>
				</div>
			)}

			<div
				className='block text-xl text-black font-semibold top-[-38px] left-0 absolute'
				htmlFor='image-upload'
			>
				Image
			</div>
			<label
				htmlFor='image-upload'
				className='cursor-pointer flex flex-col items-center gap-4 p-10'
			>
				<div>
					<img src={ImageIcon} alt='Icon' />
				</div>
				<p className='text-gray-600'>
					<span className='font-semibold text-gray-800'>Click to upload</span>{' '}
					or drag and drop
					<br />
					only <span className='font-bold'>images</span> (png, jpg, gif…)
				</p>

				{fileName && (
					<p className='text-green-600 font-medium'>Selected: {fileName}</p>
				)}

				<input
					id='image-upload'
					type='file'
					accept='image/*'
					className='hidden'
					onChange={handleFileChange}
				/>
			</label>
		</div>
	);
};

export default ImageInput;
